import Entity from 'utilities/entity';
import Phase from './phase';
import Process from './process';
import Skill from './skill';
import Theme from './theme';

class Project extends Entity {
    
    phases() {
        return this.hasMany(Phase);
    }

    process() {
        return this.hasMany(Process);
    }

    skills() {
        return this.hasMany(Skill);
    }

    theme() {
        return this.hasOne(Theme);
    }
}

export default new Project();